





















































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import Appconst from '../../../../lib/appconst'
@Component({
    name:'specialProjectDetailDoc'
})
export default class SpecialProjectDetailDoc extends AbpBase {
    //初始化数据
    initData:any = {
        status: 1,
        loading: false,
        tableData: {
            loading: true,
            title: [
                {
                    title: '',
                    key: 'title',
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                on: {
                                    click: ()=>{
                                        this.ToDetail(params.row.id);                                            
                                    }
                                }
                            }, params.row.title)
                        ])
                    }
                },
                {
                    title: '',
                    key: 'creationTime',
                    width: 250,
                    render: (h:any, params:any)=>{
                        let date = params.row.creationTime ? new Date(params.row.creationTime).getFullYear()+'年'+(new Date(params.row.creationTime).getMonth()+1)+'月'+new Date(params.row.creationTime).getDate()+'日' : ''
                        return h('Row', [
                            h('Col', {}, date)
                        ])
                    }   
                },
                {
                    title: '',
                    key: '',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: ()=>{
                                        this.Delete(params.row.id);                                            
                                    }
                                }
                            }, '删除')
                        ])                            
                    }
                }
            ],
            content: []
        },
        modalData: {
            status: false,
            loading: true,
            content: {
                attachs: []
            }
        },
        detailData: {},            
        fileUrl: Appconst.fileUrl
    }
    //删除文件
    async DeleteFile(res:any) {
        await Ajax.post('/api/File/DeleteTempFile?filename='+res.response.result);
        this.initData.modalData.content.attachs.splice(this.initData.modalData.content.attachs.indexOf(res.response.result), 1);
    }
    //上传成功回调
    UploadSuccess(res:any) {
        this.initData.modalData.content.attachs.push(res.result);
    }
    //弹窗
    ShowModal(type:any) {
        this.initData.modalData.status = true;
        this.initData.modalData.type = type;
    }
    //提交
    async Add() {
        (this.$refs as any).addFrom.validate(async (valid:boolean)=>{
            if(valid){
                if(this.initData.modalData.type == 'add'){
                    this.initData.modalData.content.projectId = this.initData.id;
                    await Ajax.post('/api/services/app/SpecialProject/CreateDocAsync', this.initData.modalData.content);
                    this.$Message.success('新增成功!');
                    this.initData.modalData.status = false;
                    this.GetDetailData();
                }else{
                    //处理文件上传
                    this.initData.modalData.content.projectId = this.initData.id;
                    await Ajax.put('/api/services/app/SpecialProject/UpdateDocAsync', this.initData.modalData.content);
                    this.$Message.success('修改成功!');
                    this.initData.modalData.status = false;
                    this.GetDetailData();
                }
            }else{                    
                setTimeout(() => {
                    this.initData.modalData.loading = false;
                    this.$nextTick(() => {
                        this.initData.modalData.loading = true;
                    });
                }, 1000);
            }
        })
    }
    //删除
    async Delete(id:any) {
        await Ajax.delete('/api/services/app/SpecialProject/DeleteDocAsync?Id='+id);
        this.$Message.success('删除成功!');
        this.GetData();
    }
    //详情切换
    ToDetail(id:any) {
        this.initData.detailId = id;
        this.GetDetailData();
    }
    //获取详情数据
    GetDetailData() {
        this.initData.loading = true;
        Ajax.get('/api/services/app/SpecialProject/GetDocDetailAsync?Id='+ this.initData.detailId).then((res:any)=>{                
            this.initData.status = 2;
            this.initData.detailData = res.data.result;
            this.initData.modalData.content = res.data.result;
            if(this.initData.modalData.content.attachs){
                this.initData.modalData.content.attachsFormal = this.initData.modalData.content.attachs.map((item:any)=>{
                    return {
                        attachName: item.attachName,
                        name: item.attachName,
                        fileId: item.fileId,
                        url: item.url,
                        isFormal: true
                    }
                });
                this.initData.modalData.content.attachs = [];
            }
            this.initData.loading = false;
        });
    }

    //获取数据
    async GetData(){
        this.initData.tableData.loading = true;
        this.initData.tableData.content = (await Ajax.get('/api/services/app/SpecialProject/GetDocByProjectIdAsync?Id='+ this.initData.id)).data.result.items;            
        this.initData.tableData.loading = false;
    }
    mounted(){
        this.initData.id = this.$route.query.id;
        this.GetData();
    }
    //验证
    rules:any = {
        title: [{required: true, message: '请填写项目文档标题', trigger: 'blur'}],
        content: [{required: true, message: '请填写项目文档内容', trigger: 'blur'}],
    }
}
